import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";

export enum WaitingPeriodBeforePayoutStarts {
  SIXTEEN_DAYS = "SIXTEEN_DAYS",
}

export interface SopSicknessLeavePriceRequestInfo extends BaseProduct {
  dailyPayoutAmount: number;
  waitingPeriodBeforePayoutStarts: WaitingPeriodBeforePayoutStarts;
  age?: number; // Required to get price, but made optional in order to trigger backend error if customers nin/dateOfBirth is missing
}
